var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivate = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 14,
  viewBox: "0 0 16 14",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M7 0c4.15 0 2 5.357 2 5.357C8.464 6.43 7.929 7.5 9 8.571c.8.8 5 1.072 5 3.215v.204c0 1.11-.897 2.01-2.006 2.01H2.006C.898 14 0 13.1 0 11.99v-.204C0 9.643 3.929 9.643 5 8.57c.982-.982.614-1.964.133-2.946L5 5.357S2.85 0 7 0m8 4h.01c.546 0 .99.443.99 1.01v1.98c0 .558-.451 1.01-.99 1.01h-4.02A.995.995 0 0 1 10 6.99V5.01c0-.558.451-1.01.99-1.01H11V3l.005-.15A2 2 0 0 1 15 3zm-1.007-1.117A1 1 0 0 0 12 3v1h2V3Z"
})));
export default SvgPrivate;